module.exports = __webpack_public_path__ + "img/persona_02.11f6afed.jpg";